<template src="./SerieFormularios.html"></template>

<script>
import DatePicker from "../DatePicker/Datepicker";
export default {
  data() {
    return {
      valid: false,
      inset: false,
      reglasObligatorio: [v => !!v || "Campo obligatorio"],
      padding: "2% 3% 2% 3%",
      options: {
        locale: "es",
        format: "YYYY/MM/DD",
        clearable: true
      },
      valorVariable: 0,
      //array_lista && array_lista_multiple
      cantidaElementosMostrar: 0,
    };
  },
  props: {
    borrable: {
      type: Boolean,
      default: true
    },
    titulo: {
      type: String,
      default: "Título del formulario"
    },
    deshabilitado: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$store.dispatch("setSerieFormularios", []);
  },
  computed: {
    gridTemplate: function() {
      let resultado_grid = "1fr 1fr 1fr";
      if (this.formularios && this.formularios.length > 0) {
        this.formularios[0].variables.map(variable => {
          if (variable.nombre.length >= this.valorVariable) {
            this.valorVariable = variable.nombre.length;
            if (this.valorVariable >= 22 && this.valorVariable <= 30) {
              resultado_grid = "1fr 1fr";
            } else if (this.valorVariable > 30)  {
              resultado_grid = "1fr";
            } else {
              resultado_grid = "1fr 1fr 1fr";
            }
          }
        });
      }
      return resultado_grid;
    },
    formularios: function() {
      return this.$store.getters.getSerieFormularios;
    },
    esquemaFormularioSerie: function() {
      return this.$store.getters.getEsquemaFormularioSerie;
    }
  },
  methods: {
    posicionSeleccionLista(arrayVariables, index, indiceSerie) {
      arrayVariables[index].seleccion = {
        lista: arrayVariables[index].lista,
        valor: arrayVariables[index].valor
      };
      const m_formularios = this.formularios;
      m_formularios[indiceSerie] = {variables: arrayVariables};
      this.$store.dispatch("setSerieFormularios", m_formularios);
      this.construccionOpcionesLista(index, indiceSerie)
    },
    construccionOpcionesLista(index, indiceSerie){
      const condiciones = this.formularios[indiceSerie].variables[index].seleccion;
      const arrayVariables = this.formularios[indiceSerie].variables;
      arrayVariables.map((e, i) => {
        if (e.indexPadre === index) {
          e.valor = null; 
          this.posicionSeleccionLista(arrayVariables, i, indiceSerie);
          e.lista_seleccionada = e.opciones_lista.filter(x => x.condiciones.some(e => e.lista === condiciones.lista && e.valor === condiciones.valor));
          e.habilitado = this.habilitarSelect(e.lista_seleccionada)
        }
      });
      const m_formularios = this.formularios;
      m_formularios[indiceSerie] = {variables: arrayVariables};
      this.$store.dispatch("setSerieFormularios", m_formularios);
      // this.$store.dispatch("setVariablesFormularios", arrayVariables);
      // this.renderizar += 1
    },
    habilitarSelect(lista_seleccionada){
      if (lista_seleccionada.length > 0) return true
      return false
    },
    //  Funcion para calcular el numero de opciones seleccionadas dependiendo de la cantidad del texto seleccionado
    calcularCantidadSeleccionada(arrayValores, formulario, index, indiceSerie) {
      this.posicionSeleccionLista(formulario, index, indiceSerie)
      let maximaLongitud = 0;
      arrayValores.map(variable => {
        if (variable.length >= maximaLongitud) {
          maximaLongitud = variable.length;
          if (maximaLongitud >= 7) {
            this.cantidaElementosMostrar = 0;
          } else if (maximaLongitud >= 4 && maximaLongitud < 7) {
            this.cantidaElementosMostrar = 1;
          } else {
            this.cantidaElementosMostrar = 2;
          }
        }
      });
      return arrayValores;
    },
    /**
     * Se encarga de eliminar un determinado formulario de la lista
     */
    eliminarFormulario(indice) {
      document.activeElement.blur(); // Evitar el autofocus en el siguiente formulario.
      if (
        this.$store.getters.getSerieFormularios === null ||
        this.$store.getters.getSerieFormularios === undefined
      ) {
        this.$store.dispatch("setSerieFormularios", []);
      }
      const lodashClonedeep = require("lodash.clonedeep");
      let serie = this.$store.getters.getSerieFormularios;
      serie.splice(indice, 1);
      this.$store.dispatch(
        "setSerieFormularios",
        lodashClonedeep(serie)
      );
    },
    /**
     * Agrega un arreglo de variablesFormulario a la lista de formularios
     * Se utiliza el objeto JSON para crear un clon de EsquemaFormulario dentro del store
     */
    agregarFormulario() {
      if (
        this.esquemaFormularioSerie &&
        this.esquemaFormularioSerie.variables
      ) {
        const lodashClonedeep = require("lodash.clonedeep"); // Librería par poder hacer un deepClone
        if (
          this.$store.getters.getSerieFormularios === null ||
          this.$store.getters.getSerieFormularios === undefined
        ) {
          this.$store.dispatch("setSerieFormularios", []);
        }
        if (
          this.$store.getters.getEsquemaFormularioSerie &&
          this.$store.getters.getEsquemaFormularioSerie.variables
        ) {
          let serie = this.$store.getters.getSerieFormularios;
          serie.push(
            lodashClonedeep(this.$store.getters.getEsquemaFormularioSerie)
          );
          this.$store.dispatch("setSerieFormularios", serie);
        }
      } else {
        console.log("esquemaFormularioSerie", this.esquemaFormularioSerie);
      }
    }
  },
  beforeDestroy() {
    this.$store.dispatch("setSerieFormularios", []);
    this.$store.dispatch("setEsquemaFormularioSerie", null);
  },
  components: {
    DatePicker
  }
};
</script>

<style lang="scss" src="./SerieFormularios.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SerieFormularios/SerieFormularios.vue